import styled from "styled-components";

export const MensageriaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};

  /* Mesma convencao das demais telas de config (ex.: PagamentoCombinar):
     descricao alinhada a esquerda, com respiro e divisor central via ::after. */
  .descricao-texto {
    width: 100%;
    text-align: left;
    color: ${(props) => props.theme.colors.tertiary};
    line-height: 1.6;
    padding: 3rem 0;
  }

  /* Subtitulo da sacola: mesmo estilo, porem mais discreto */
  .descricao-sutil {
    padding: 2rem 0 0 0;
  }

  /* Divisor central, no mesmo estilo do ::after das demais telas de config */
  /* QR Code de conexao do WhatsApp */
  .qr-container {
    align-self: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
    text-align: center;
    max-width: 32rem;
  }

  .qr-instrucao {
    color: ${(props) => props.theme.colors.tertiary};

    strong {
      font-weight: bold;
    }
  }

  .qr-image {
    width: 24rem;
    height: 24rem;
    border-radius: 8px;
  }

  .qr-aguardando {
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
  }

  .qr-expirado {
    align-self: center;
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    font-weight: bold;
  }

  /* Tabela exibida quando o WhatsApp esta conectado (numero | nome | status) */
  .conectado-tabela {
    width: 100%;
    padding: 1rem 0;

    /* Reduz o padding gigante do cabecalho padrao do Table (5rem -> 1.2rem) */
    .th-wrapper {
      padding: 1.2rem 2rem !important;
    }

    .badge-conectado {
      display: inline-block;
      padding: 0.2rem 1.2rem;
      border-radius: 20px;
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) =>
        props.theme.mode === "dark"
          ? props.theme.colors.tertiary
          : props.theme.colors.white};
      font-weight: bold;
    }
  }

  .divisor {
    align-self: center;
    width: 30%;
    height: 2px;
    border-radius: 100%;
    background-color: ${(props) => props.theme.colors.elements};
    margin: 1rem 0;
  }

  /* Botao Conectar WhatsApp (pill centralizado) */
  .btn-conectar {
    align-self: center;
    margin: 2rem 0;
    padding: 0.8rem 2.4rem;
    border: none;
    border-radius: 30px;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) =>
      props.theme.mode === "dark"
        ? props.theme.colors.tertiary
        : props.theme.colors.white};
    font-weight: bold;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  /* Recuperacao de Sacola Abandonada */
  .sacola-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    width: 100%;
  }

  .sacola-titulo {
    font-weight: bold;
    color: ${(props) => props.theme.colors.tertiary};
  }

  /* Campos: tempo de envio + cupom (mesmo respiro de .input-container) */
  .input-container {
    width: 100%;
    padding: 4rem 0;
  }

  .grid-campos {
    display: flex;
    gap: 2.4rem;
    align-items: flex-start;

    > * {
      flex: 1 0 0;
      min-width: 0;
    }
  }

  /* Previa das mensagens */
  .previa {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .previa-label {
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.tertiary};
  }

  .previa-cards {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .previa-card {
    width: 100%;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-word;
    padding: 2.8rem 2.6rem;
    line-height: 1.5;
    color: ${(props) => props.theme.colors.tertiary};
    background-color: ${(props) =>
      props.theme.mode === "light" ? "white" : props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.elements};
    border-radius: 15px;
  }

  /* Bloco de teste de envio */
  .teste-envio {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.8rem;
    margin-top: 2rem;
    width: 100%;
    align-items: center;
  }

  .btn-testar {
    padding: 0.8rem 2.4rem;
    border: 1px solid ${(props) => props.theme.colors.primary};
    border-radius: 30px;
    background: transparent;
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;

    &:hover:not(:disabled) {
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) =>
        props.theme.mode === "dark"
          ? props.theme.colors.tertiary
          : props.theme.colors.white};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .teste-hint {
    color: ${(props) => props.theme.colors.tertiary};
  }

  .resultado-teste {
    padding: 0.6rem 1.2rem;
    border-radius: 8px;

    &.sucesso {
      background-color: ${(props) => props.theme.colors.dashBgUp};
      color: ${(props) => props.theme.colors.dashBorderUp};
    }

    &.erro {
      background-color: ${(props) => props.theme.colors.dashBgDown};
      color: ${(props) => props.theme.colors.dashBorderDown};
    }
  }

  @media (max-width: 650px) {
    .grid-campos {
      flex-direction: column;
      gap: 1.6rem;
    }
  }
`;
